// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_card.scss
// module id = 34
// module chunks = 0